import client from '../utils/client';
import { collectionsUrl } from '../store/constants/api';
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const collectionService = {
  collectionsList,
  addCollection,
  getCollection,
  updateCollection
}

function collectionsList(pageID, perPage, searchInput = '') {
  let searchQuery = '';
  if(searchInput !== '') {
    searchQuery = '&s=' + searchInput;
  }
  return client.get(collectionsUrl + '?page=' + pageID + '&per_page=' + perPage + searchQuery)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function addCollection(formDate) {
  return client.post(collectionsUrl + '/create', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function getCollection(collectionID) {
  return client.get(collectionsUrl + '/' + collectionID + '/show')
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function updateCollection(formDate) {
  return client.post(collectionsUrl + '/update', formDate)
    .then((response) => {
      return response
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function handleResponse(response) {
  response = response.response
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors;
    return Promise.reject(error);
  }

  return data;
}